import { Link } from 'react-router-dom';
import './card.styles.scss';

const Card = ({ project }) => {
  const myStyle = {
    backgroundImage: `url(${project.imageUrl})`,
  };
  return (
    <div className={`project-container ${project.size} container-1`}>
      <article className='card card--1'>
        <div style={myStyle} className='card__img'></div>
        <Link to={project.app} className='card_link'>
          <div style={myStyle} className='card__img--hover'></div>
        </Link>
        <div className='card__info'>
          <span className='card__category'>{project.usedTech}</span>
          <h3 className='card__title'>{project.title.toUpperCase()}</h3>
          <span className='card__by'>{project.desc}</span>
        </div>
      </article>
    </div>
  );
};

export default Card;
